/**
 * Click→first-frame metric (browser open path, 2026-08-21 audit item 7 seed).
 *
 * Before this, the open click was never timestamped ANYWHERE, so no true
 * time-to-first-frame could be reconstructed even by hand. This is the
 * smallest honest version: stamp the user gesture (panel open / Wake click),
 * report once at the first visually-live frame, one-shot per gesture.
 * Module-scope is fine client-side — one tab, one user, no replica concerns.
 */
let clickedAt: number | null = null;

/** Stamp the user gesture that should end in pixels. Re-stamping (second Wake
 *  click before frames) moves the start — the metric measures the LAST gesture,
 *  which is the one the user is actually waiting on. */
export function markBrowserOpenClicked(): void {
  clickedAt = performance.now();
}

/** One-shot: emits + returns the ms since the last unconsumed gesture, or null
 *  when no gesture is pending (agent-driven opens, replays, re-renders). */
export function reportBrowserFirstFrame(): number | null {
  if (clickedAt === null) return null;
  const ms = Math.round(performance.now() - clickedAt);
  clickedAt = null;
  // eslint-disable-next-line no-console -- the [OpenPath] family is the open-time telemetry rail
  console.info(`[OpenPath] click→first-frame ${ms}ms`);
  return ms;
}

/** Test-only. */
export function __resetOpenPathForTest(): void {
  clickedAt = null;
}
